import { styled } from 'styled-components';

import { Box } from 'components/Box/Box';
import { LegacyTertiaryButton } from 'components/LegacyButton/LegacyTertiaryButton';
import { BodySmall } from 'components/Text/BodySmall';
import { colors, transition } from 'theme/theme';

export const Description = styled(BodySmall)`
  *:last-child {
    margin-bottom: 0;
  }

  ul {
    padding-left: 24px;
    list-style-type: none;

    li {
      position: relative;

      &::before {
        content: '•';
        position: absolute;
        right: 100%;
        width: 24px;
        text-align: left;
      }
    }
  }
`;

export const StyledLinkButton = styled(LegacyTertiaryButton)`
  font-size: inherit;
`;

export const BigButton = styled(Box)`
  cursor: pointer;
  padding: 15px 15px 5px;
  display: block;
  width: 100%;
  box-shadow:
    0 -4px white inset,
    0 4px white inset;
  text-align: left;
  transition: all ${transition};

  &:hover,
  &:focus {
    background: ${colors.backgroundGrey};

    span {
      text-decoration: underline;
    }
  }
`;
